'use strict';

import CustomAutoscroll from './turbo/CustomAutoscroll.js';
import FormActionHandler from './turbo/FormActionHandler.js';
import GetFormHandler from './turbo/GetFormHandler.js';
import MissingFrameHandler from './turbo/MissingFrameHandler.js';

new CustomAutoscroll();
new FormActionHandler();
new GetFormHandler();
new MissingFrameHandler();
